import { restClient } from '@/Core'
import type { Chat, User } from '../Contracts'
import { extractChatUsers, mapApiChat, type ApiChat } from '../Helpers/apiMappers'

/**
 * Get-or-create чату сутності (кнопка «Чат» у картці завдання). Бекенд
 * ідемпотентний: перший виклик створює груповий чат з учасниками
 * завдання — керівник, автор, виконавці, спостерігачі (201), наступні повертають той самий чат (200), а
 * натискач, якого ще немає у складі, доєднується автоматично (self-join).
 * Тому ні name, ні participantIds слати не потрібно.
 */
export const OpenEntityChatTask = async (
    entityType: string,
    entityUuid: string
): Promise<{ chat: Chat; users: User[] }> => {
    const response = (await restClient.post('/services/chat/chats', {
        json: { type: 'group', entityType, entityUuid },
    })) as ApiChat | null

    const api = response ?? {}

    return { chat: mapApiChat(api), users: extractChatUsers(api) }
}
